import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import ForgetPassword from '@/components/ForgetPassword'
import Home from '@/components/Home'
import UpdateNum from '@/components/UpdateNum'
import checkNum from '@/components/checkNum'

import Center from '@/Person/Center'
import MyIntro from '@/Person/MyIntro'
import MyClient from '@/Person/MyClient'

import ShopList from '@/Shop/ShopList'
import ShopSet from '@/Shop/ShopSet'
import EditShop from '@/Shop/EditShop'
import NewShop from '@/Shop/NewShop'
import SetMenu from '@/Shop/SetMenu'
import SetPerfer from '@/Shop/SetPerfer'
import NewDish from '@/Shop/NewDish'
import EditDish from '@/Shop/EditDish'
import NewPackage from '@/Shop/NewPackage'
import EditPackage from '@/Shop/EditPackage'
import PackageTags from '@/Shop/PackageTags'
import PackageDish from '@/Shop/PackageDish'
import setCategory from '@/Shop/setCategory'
import SetSeat from '@/Seat/SetSeat'
import TagMenu from '@/Shop/TagMenu'
import PrinterList from '@/Shop/PrinterList'
import PrinterSet from '@/Shop/PrinterSet'


import PrintList from '@/Print/PrintList'
import PrintSet from '@/Print/PrintSet'


import payList from '@/Pay/payList'
import CreatPaymethods from '@/Pay/CreatPaymethods'
import EditPay from '@/Pay/EditPay'
import paySet from '@/Pay/paySet'

import StaffList from '@/Staff/StaffList'
import newStaff from '@/Staff/newStaff'
import EditStaff from '@/Staff/EditStaff'
import CookInfo from '@/Staff/CookInfo'

import ContactUs from '@/components/ContactUs'
import NoData from '@/Shop/NoData'
import Dishes from '@/Shop/Dishes'
import DishDetail from '@/Shop/DishDetail'
import PackageDetail from '@/Shop/PackageDetail'
import ShopStatus from '@/Shop/ShopStatus'
import EditTable from '@/Shop/EditTable'
import EditBook from '@/Shop/EditBook'
import ServiceBill from '@/Shop/ServiceBill'
import PhoneList from '@/Shop/PhoneList'
import CustomerList from '@/Shop/CustomerList'
import CustomerRecordDtl from '@/Shop/CustomerRecordDtl'
import TakeOrderDetail from '@/Shop/TakeOrderDetail'
import StockList from '@/Shop/StockList'
import DayStockdetail from '@/Shop/DayStockdetail'
import YearsStockdetail from '@/Shop/YearsStockdetail'
import ReceiptInfoSet from '@/Shop/ReceiptInfoSet'

import MonthReport from '@/Report/MonthReport'
import MonthDetail from '@/Report/MonthDetail'
import WeekReport from '@/Report/WeekReport'
import WeekDetail from '@/Report/WeekDetail'
import DayReport from '@/Report/DayReport'
import OrderDetail from '@/Report/OrderDetail'
import CookTime from '@/Report/CookTime'
import StaffReport from '@/Report/StaffReport'
import TableRank from '@/Report/TableRank'
import MenuRank from '@/Report/MenuRank'
import CustomerTime from '@/Report/CustomerTime'

import StaffTimeSeting from '@/Service/StaffTimeSeting'
import EditBookTime from '@/Service/EditBookTime'
import Detail from '@/Service/Detail'
import StaffBookForm from '@/Service/StaffBookForm'

import PlatformList from '@/Platform/PlatformList'
import PlatformBind from '@/Platform/PlatformBind'
import PlatformInfo from '@/Platform/PlatformInfo'
import ItemDetails from '@/Platform/ItemDetails'
import PlatformInfoAdd from '@/Platform/PlatformInfoAdd'
import PlatformInfoEdit from '@/Platform/PlatformInfoEdit'
import ItemInfoAdd from '@/Platform/ItemInfoAdd'
import UnitList from '@/Platform/UnitList'
import AddUnitList from '@/Platform/AddUnitList'
import UnitManage from '@/Platform/UnitManage'
import ItemInfoList from '@/Platform/ItemInfoList'
import PlatformDetail from '@/Platform/PlatformDetail'

import AddressList from '@/Address/AddressList'
import EditAddress from '@/Address/EditAddress'
import CreatAddress from '@/Address/CreatAddress'

import BC from '@/components/BC'
import RechargeAmountSetting from '@/Shop/RechargeAmountSetting'
import addRechargeAmount from '@/Shop/addRechargeAmount'

import invoice from '@/Shop/invoice'


Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        through: true
      },
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        through: true
      },
    },
    {
      path: '/ForgetPassword',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: {
        through: true
      },
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        through: true
      },
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/UpdateNum',
      name: 'UpdateNum',
      component: UpdateNum
    },
    {
      path: '/checkNum',
      name: 'checkNum',
      component: checkNum
    },
    {
      path: '/ShopList',
      name: 'ShopList',
      component: ShopList
    },
    {
      path: '/ShopSet/:id',
      name: 'ShopSet',
      component: ShopSet
    },
    {
      path: '/EditShop/:type',
      name: 'EditShop',
      component: EditShop
    },
    {
      path: '/ReceiptInfoSet',
      name: 'ReceiptInfoSet',
      component: ReceiptInfoSet
    },
    {
      path: '/StockList',
      name: 'StockList',
      component: StockList
    },
    {
      path: '/DayStockdetail',
      name: 'DayStockdetail',
      component: DayStockdetail
    },
    {
      path: '/YearsStockdetail',
      name: 'YearsStockdetail',
      component: YearsStockdetail
    },
    {
      path: '/NewShop',
      name: 'NewShop',
      component: NewShop
    },
    {
      path: '/payList',
      name: 'payList',
      component: payList
    },
    {
      path: '/SetMenu',
      name: 'SetMenu',
      component: SetMenu
    },
    {
      path: '/SetPerfer/:id',
      name: 'SetPerfer',
      component: SetPerfer
    },
    {
      path: '/NewDish',
      name: 'NewDish',
      component: NewDish
    },
    {
      path: '/setCategory',
      name: 'setCategory',
      component: setCategory
    },
    {
      path: '/EditDish/:id',
      name: 'EditDish',
      component: EditDish
    },
    {
      path: '/NewPackage',
      name: 'NewPackage',
      component: NewPackage
    },
    {
      path: '/EditPackage/:id',
      name: 'EditPackage',
      component: EditPackage
    },
    {
      path: '/PackageTags/:id',
      name: 'PackageTags',
      component: PackageTags
    },
    {
      path: '/PackageDish/:id',
      name: 'PackageDish',
      component: PackageDish
    },
    {
      path: '/Center',
      name: 'Center',
      component: Center
    },
    {
      path: '/MyClient',
      name: 'MyClient',
      component: MyClient
    },
    {
      path: '/MyIntro',
      name: 'MyIntro',
      component: MyIntro
    },
    {
      path: '/SetSeat',
      name: 'SetSeat',
      component: SetSeat
    },
    {
      path: '/TagMenu/:id',
      name: 'TagMenu',
      component: TagMenu
    },
    // staff
    {
      path: '/StaffList',
      name: 'StaffList',
      component: StaffList
    },
    {
      path: '/newStaff',
      name: 'newStaff',
      component: newStaff
    },
    {
      path: '/EditStaff/:id',
      name: 'EditStaff',
      component: EditStaff
    },
    {
      path: '/CookInfo',
      name: 'CookInfo',
      component: CookInfo
    },


    {
      path: '/NoData',
      name: 'NoData',
      component: NoData
    },
    {
      path: '/Dishes',
      name: 'Dishes',
      component: Dishes
    },
    {
      path: '/DishDetail/:id',
      name: 'DishDetail',
      component: DishDetail
    },
    {
      path: '/PackageDetail/:id',
      name: 'PackageDetail',
      component: PackageDetail
    },

    {
      path: '/MonthReport',
      name: 'MonthReport',
      component: MonthReport
    },
    {
      path: '/MonthDetail',
      name: 'MonthDetail',
      component: MonthDetail
    },
    {
      path: '/WeekReport',
      name: 'WeekReport',
      component: WeekReport
    }, {
      path: '/WeekDetail',
      name: 'WeekDetail',
      component: WeekDetail
    },
    {
      path: '/DayReport',
      name: 'DayReport',
      component: DayReport
    },
    {
      path: '/OrderDetail/:id',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/CookTime',
      name: 'CookTime',
      component: CookTime
    },
    {
      path: '/StaffReport',
      name: 'StaffReport',
      component: StaffReport
    },
    {
      path: '/TableRank',
      name: 'TableRank',
      component: TableRank
    },
    {
      path: '/MenuRank',
      name: 'MenuRank',
      component: MenuRank
    }, {
      path: '/CustomerTime',
      name: 'CustomerTime',
      component: CustomerTime
    }, {
      path: '/ShopStatus',
      name: 'ShopStatus',
      component: ShopStatus
    }, {
      path: '/EditTable',
      name: 'EditTable',
      component: EditTable
    }, {
      path: '/EditBook',
      name: 'EditBook',
      component: EditBook
    }, {
      path: '/ServiceBill',
      name: 'ServiceBill',
      component: ServiceBill
    }, {
      path: '/StaffTimeSeting',
      name: 'StaffTimeSeting',
      component: StaffTimeSeting
    }, {
      path: '/EditBookTime',
      name: 'EditBookTime',
      component: EditBookTime
    }, {
      path: '/Detail',
      name: 'Detail',
      component: Detail
    }, {
      path: '/StaffBookForm',
      name: 'StaffBookForm',
      component: StaffBookForm
    }, {
      path: '/PhoneList',
      name: 'PhoneList',
      component: PhoneList
    }, {
      path: '/CustomerList/:phone',
      name: 'CustomerList',
      component: CustomerList
    }, {
      path: '/CustomerRecordDtl/:phone/:type',
      name: 'CustomerRecordDtl',
      component: CustomerRecordDtl
    }, {
      path: '/TakeOrderDetail/:id',
      name: 'TakeOrderDetail',
      component: TakeOrderDetail
    }, {
      path: '/CreatPaymethods',
      name: 'CreatPaymethods',
      component: CreatPaymethods
    }, {
      path: '/EditPay/:id',
      name: 'EditPay',
      component: EditPay
    }, {
      path: '/paySet',
      name: 'paySet',
      component: paySet
    }, {
      path: '/BC/:id',
      name: 'BC',
      component: BC,
      meta: {
        through: true
      },
    }, {
      path: '/PrinterList',
      name: 'PrinterList',
      component: PrinterList,
    }, {
      path: '/PrinterSet',
      name: 'PrinterSet',
      component: PrinterSet,
    }, {
      path: '/PrintList',
      name: 'PrintList',
      component: PrintList,
    }, {
      path: '/PrintSet/:type',
      name: 'PrintSet',
      component: PrintSet,
    },

    {
      path: '/PlatformList',
      name: 'PlatformList',
      component: PlatformList,
    }, {
      path: '/PlatformBind',
      name: 'PlatformBind',
      component: PlatformBind,
    }, {
      path: '/PlatformInfo',
      name: 'PlatformInfo',
      component: PlatformInfo,
    }, {
      path: '/ItemDetails',
      name: 'ItemDetails',
      component: ItemDetails,
    }, {
      path: '/PlatformInfoAdd',
      name: 'PlatformInfoAdd',
      component: PlatformInfoAdd,
    }, {
      path: '/ItemInfoList',
      name: 'ItemInfoList',
      component: ItemInfoList,
    }, {
      path: '/PlatformDetail',
      name: 'PlatformDetail',
      component: PlatformDetail,
      meta: {
        through: true
      },
    },
    {
      path: '/ItemInfoAdd',
      name: 'ItemInfoAdd',
      component: ItemInfoAdd
    },
    {
      path: '/AddUnitList',
      name: 'AddUnitList',
      component: AddUnitList,
    }, {
      path: '/UnitList',
      name: 'UnitList',
      component: UnitList,
    }, {
      path: '/UnitManage',
      name: 'UnitManage',
      component: UnitManage,
    }, {
      path: '/PlatformInfoEdit/:id',
      name: 'PlatformInfoEdit',
      component: PlatformInfoEdit,
    }, {
      path: '/AddressList',
      name: 'AddressList',
      component: AddressList,
    }, {
      path: '/EditAddress/:id',
      name: 'EditAddress',
      component: EditAddress,
    }, {
      path: '/CreatAddress',
      name: 'CreatAddress',
      component: CreatAddress,
    }, {
      path: '/RechargeAmountSetting',
      name: 'RechargeAmountSetting',
      component: RechargeAmountSetting,
    },
    {
      path: '/addRechargeAmount',
      name: 'addRechargeAmount',
      component: addRechargeAmount,
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice,
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (sessionStorage.token || to.matched.some(record => record.meta.through)) {
    next()
  } else {
    return next({
      path: '/'
    })
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js